import React from "react";
import { PlantShutdownItem } from "../../../models/weeklyTimeline";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationArrow } from "@fortawesome/free-solid-svg-icons";

interface PlantShutdownItemProps {
  item: PlantShutdownItem;
  bottomLastMargin: string;
  verticalLineStyle: string;
}

const PlantShutdownItemComponent: React.FC<PlantShutdownItemProps> = ({
  item,
  bottomLastMargin,
  verticalLineStyle,
}) => {
  return (
    <div className={`mt-1 flex flex-col ${bottomLastMargin}`}>
      <div className="flex flex-row">
        <div className="flex h-[30px] w-[30px] min-w-[30px] items-center justify-center rounded-full bg-gray-500">
          <FontAwesomeIcon className="h-4 w-4 text-white" icon={faLocationArrow} />
        </div>
        <h1 className="ml-3 flex items-center justify-center text-sm text-[#212322]">
          Plant Shutdown
        </h1>
      </div>
      <div className="mt-1 flex flex-row items-stretch">
        <div className={`ml-[0.7rem] ${verticalLineStyle}`} />
        <h2 className="ml-6 text-xs font-light text-gray-500">
          <div className="font-semibold">✅ Coverage Confirmed</div>
          <div className="font-normal italic text-[10px] text-[#212322] pl-5">
            No additional updates logged today.
          </div>
        </h2>
      </div>
    </div>
  );
};

export default PlantShutdownItemComponent; 